<template>
    <transition name="modal">
        <div class="sample-dialog-modal-mask">
            <div class="payload-sample-modal" style="width: 600px" @click.stop>
                <div class="dialog-title" v-t="'message.title_buddy_bot_api_payload_template'"></div>
                <hr class="dialog-hr">
                <div class="confirm-body">
                    <pre style="white-space: pre; overflow: auto">{{ displayData }}</pre>
                </div>
                <div class="dialog-button-field">
                    <el-button class="dialog-cancel-button" @click="$emit('cancel')" v-t="'message.action_close'"></el-button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    props: ['targetBotParam'],
    data() {
        return {
            customParamsJson: null,
            rawData: {
                "chatBotName": null,
                "senderUserName": "<user_name>@<tenant_name>",
                "languageIndex": "<languageIndex>",
                "type": 1,
                "data": "<ChatMessage>",
                customParams: null
            },
            displayData: null,
        };
    },

    created() {
        try {
            this.customParamsJson = JSON.parse(this.targetBotParam.customParamsJson);
        } catch (error) {
            console.error("Invalid JSON string in customParamsJson", error);
            this.customParamsJson = {};
        }
        this.rawData.customParams = this.customParamsJson;
        this.rawData.chatBotName = this.targetBotParam.objectName + "@<tenant_name>";
        this.displayData = JSON.stringify(this.rawData, null, 4);
    },
};
</script>

<style scoped>


.payload-sample-modal {
    background: #fff;
    position: absolute;
    padding: 0;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 500px;
    max-height: 80vh;
    transition: all .3s ease;
    border-radius: 4px;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    -webkit-overflow-scrolling: touch;
    overflow: hidden;
}
.sample-dialog-modal-mask {
    position: absolute;
    z-index: 1999;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .3);
    display: table;
    transition: opacity .3s ease;
}
.confirm-body {
    padding-left: 20px;
    padding-right: 20px;
    font-size: 14px;
}
</style>
